import {IntermediatePart} from "../../intermediatePart";
import {VANITY_TYPES} from "../../constants";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";

/**
 * Common base class for the vanity cabinet sub parts (handles, pulls, legs, middle, ...).
 * Keeps the click logic in one place: clicking any of those sub parts switches
 * the vanity to the "vanity_cabinet" type and refreshes the vanity parts.
 */
export default class VanityCabinetSubPartCommon extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
  }

  handleClick(ignoreLocked) {
    const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
    const vanityParent = this.getParent().getParent();
    if (!featureIsLocked) {
      vanityParent.vanity_type = VANITY_TYPES.vanity_cabinet;
    }
    super.handleClick(ignoreLocked);
    if (!featureIsLocked) {
      vanityParent.updateVanityParts();
      if ((
        (vanityParent.vanity_type === VANITY_TYPES.vanity_cabinet)
        && vanityParent.vanityCabinet?.activeFeature
        && !vanityParent.vanityCabinet.disabled
        && Object.keys(vanityParent.vanityCabinet.layerPositions).every(pos => !vanityParent.vanityCabinet.layerPositions[pos])
      )) {
        navFeatureCLick(vanityParent.vanityCabinet.activeFeature, false, false, false)
      }
    }
  }

}
